import React from 'react';
import { Link } from 'gatsby';

import { ApiContext } from '../../context/apicontext';
import { slugifyHandle, formatLocaleTime } from '../../utils/common';

const Curated = () => {
	const Api = React.useContext(ApiContext);

	const [curated, setCurated] = React.useState(undefined);

	React.useEffect(() => {
		Api.fetch('curated', {}, (result) => {
			if (result.response === 1) setCurated(result.curated);
		});
	}, [Api, setCurated]);

	if (!curated || curated.length === 0)
		return (<></>);

	return (
		<React.Fragment>
			<h2>Recommended</h2>
			<p>Here are a few curated stories from Tower of the Hand's archives that may be worth another read.</p>
			{curated.map(story =>
				<div key={story.slug} className='cover-story'>
					<div className='image'>
						<img src={story.image} alt={story.title} style={{ maxWidth: '240px' }} />
					</div>
					<div className='story'>
						<h3><Link to={story.slug}>{story.title}</Link></h3>
						<div className='ledeline'>
							<span>By <b><Link to={`/members/${slugifyHandle(story.author)}`}>{story.author}</Link></b></span>
							<span>{formatLocaleTime(story.date, false)}</span>
						</div>
						<div>{story.description}</div>
					</div>
				</div>
			)}
		</React.Fragment>
	);
}

export default Curated;
